import { FC } from 'react';
import { FONT_COLOURS } from '@belong/themes';
import { ListItem } from '../../styles/List';
import { Copy } from '../../styles/Typography/Copy';
import { RegionalCountriesList } from '../RegionalCountriesList';
import { ColumnLayout, IColumnLayout } from './CountryList.styles';

export interface ICountryList extends IColumnLayout {
  countries: string[];
}

// Display a list of countries in multi-column layout
// Respects CMS ordering
const CountryList: FC<ICountryList> = ({ countries, hasColumns }: ICountryList) => {
  // If the first country is prefixed with a *, it's a regional list
  const isRegionalCountryList = countries && countries.length > 0 && countries[0].startsWith('*');

  if (isRegionalCountryList) {
    return <RegionalCountriesList countries={countries} noCollapse />;
  }

  return (
    <ColumnLayout hasColumns={hasColumns}>
      {countries.map(country => (
        <ListItem key={country}>
          <Copy as="span" variant="small" hasColor={FONT_COLOURS.BASE}>
            {country}
          </Copy>
        </ListItem>
      ))}
    </ColumnLayout>
  );
};

CountryList.displayName = 'CountryList';
export default CountryList;
